import { withInstall } from '../utils'
import _Button from './Button'
import './index.scss'
export const Button = withInstall(_Button)
export default Button
